var map = {
	"./SIGS/sig-bioinformatics.png": 834,
	"./SIGS/sig-cloud.png": 162,
	"./SIGS/sig-cog-comp.png": 400,
	"./SIGS/sig-embedded.png": 450,
	"./SIGS/sig-frontline.png": 581,
	"./SIGS/sig-web-dev.png": 446,
	"./SIGS/sig-xr.png": 806,
	"./eboard/graphic_designer.png": 642,
	"./eboard/president.png": 217,
	"./eboard/public_relations.png": 58,
	"./eboard/secretary.png": 579,
	"./eboard/sig_master.png": 308,
	"./eboard/treasurer.png": 49,
	"./eboard/vice_president.png": 13,
	"./eboard/webmaster.png": 478,
	"./hacknjit.png": 991,
	"./jerseyctf.png": 930,
	"./logos/acmLogo.png": 615,
	"./logos/acmwhite.png": 39,
	"./logos/njit_full.png": 88,
	"./socials/discord.png": 868,
	"./socials/facebook.png": 133,
	"./socials/github.png": 648,
	"./socials/instagram.png": 974,
	"./socials/linkedin.png": 246,
	"./socials/reddit.png": 725,
	"./socials/tiktok.png": 565,
	"./socials/twitch.png": 753,
	"./socials/twitter.png": 269,
	"./socials/youtube.png": 50
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;